// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.layout {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: var(--spacing-double);
}
@media only screen and (min-width: 2300px) {
  .layout {
    grid-template-columns: 1fr 6fr;
  }
}
@media only screen and (min-width: 1900px) {
  .layout {
    grid-template-columns: 1fr 5fr;
  }
}
@media only screen and (max-width: 1100px) {
  .layout {
    grid-template-columns: 1fr;
    padding: var(--spacing-half);
  }
}
.layout__aside .filter {
  padding-bottom: var(--spacing-half);
}
.layout__aside .filter__selects {
  gap: 0 calc(var(--spacing));
}
@media only screen and (max-width: 600px) {
  .layout__aside .filter__selects {
    grid-template-columns: 1fr;
  }
}
.layout__aside .filter .form-field {
  width: 100%;
  margin-bottom: var(--spacing);
  display: flex;
  flex-direction: column;
  clear: both;
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/filter-search/filter-search.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,0BAAA;AACJ;AACI;EANJ;IAOQ,8BAAA;EAEN;AACF;AAAI;EAVJ;IAWQ,8BAAA;EAGN;AACF;AADI;EAdJ;IAeQ,0BAAA;IACA,4BAAA;EAIN;AACF;AACQ;EACI,mCAAA;AACZ;AACY;EACI,2BAAA;AAChB;AACgB;EAHJ;IAIQ,0BAAA;EAElB;AACF;AACY;EACI,WAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAChB","sourcesContent":[":host {\n    display: block;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.layout {\n    position: relative;\n    display: grid;\n    grid-template-columns: 1fr 3fr;\n    gap: var(--spacing-double);\n\n    @media only screen and (min-width: 2300px) {\n        grid-template-columns: 1fr 6fr;\n    }\n\n    @media only screen and (min-width: 1900px) {\n        grid-template-columns: 1fr 5fr;\n    }\n\n    @media only screen and (max-width: 1100px) {\n        grid-template-columns: 1fr;\n        padding: var(--spacing-half);\n    }\n\n\n    &__aside {\n\n        .filter {\n            padding-bottom: var(--spacing-half);\n\n            &__selects {\n                gap: 0 calc(var(--spacing));\n\n                @media only screen and (max-width: 600px) {\n                    grid-template-columns: 1fr;\n                }\n            }\n\n            .form-field {\n                width: 100%;\n                margin-bottom: var(--spacing);\n                display: flex;\n                flex-direction: column;\n                clear: both;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
